// components/SwaggerViewer.tsx
import React, { useEffect, useState } from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import agent from '../../app/api/agent'; // adjust path if needed
import { Typography } from '@mui/material';

type Props = {
  siteId: string;
};

export default function SwaggerViewer({ siteId }: Props) {
  const [spec, setSpec] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    agent.Catalog.getOpenAPISpec(siteId)
      .then(setSpec)
      .catch((err) => {
        console.error(err);
        setError('Failed to load OpenAPI definition.');
      });
  }, [siteId]);

  if (error) return <div>{error}</div>;
  if (!spec) return <div>Loading OpenAPI spec...</div>;

  return (
     <><Typography variant="h6" mb={1}>
      API Definition
    </Typography><div style={{ height: '800px', overflow: 'auto' }}>
        <SwaggerUI spec={spec} />
      </div></>
  );
}